import React from "react";
import Axios from "../core/axios";
import { getParameterByName } from "../core/function";
import "./BindPage.less";
import { withRouter } from "react-router-dom";
import User from "../core/user";
import { message } from "../core/function";

class BindPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      banner: "",
      name: "",
      phone: "",
      code: "", // 验证码
      text: "获取验证码",
      countdown: 60,
    };
  }

  componentDidMount() {
    window._xm_slide.init();
    window.addEventListener("message", (e) => {
      e.data.token && window._xm_slide.remove();
      e.data.token && this.handSendCodeSucc(e.data);
    });
    this.getInstInfo();
  }

  getInstInfo = () => {
    const instId = getParameterByName("instId") || User.instId();
    Axios.postJSON("finance/anno/common/getInstBaseInfo", {
      instId,
    }).then((res) => {
      this.setState({
        banner: res.result.banner,
        name: res.result.name,
        phone: res.result.encryptPhone,
      });
    });
  };

  handleBind = () => {
    const params = {
      instId: getParameterByName("instId") || User.instId(),
      serverType: "INST_WALLET_REBIND_WECHAT",
      verificationCode: this.state.code,
    };
    Axios.postJSON("finance/anno/common/verifyInstAdminCode", params).then(() => {
      const param = {
        avatar: User.avatar(),
        instId: getParameterByName("instId") || User.instId(),
        nickName: User.nickName(),
        openId: User.openId(),
      };

      Axios.postJSON("finance/anno/instWallet/bindWechatOpenId", param).then(
        () => {
          this.props.history.push("/success");
        }
      );
    });
  };

  inputBlur() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }

  sendCode() {
    if (this.state.countdown > 0 && this.state.countdown < 60) {
      return;
    }
    clearInterval(this.timer);
    this.inputBlur();
    window._xm_slide.open();
  }

  handSendCodeSucc(checkData) {
    this.state.countdown = 60;
    this.countdownTick();
    this.timer = setInterval(this.countdownTick, 1000);
    this.inputBlur();
    Axios.postJSON("finance/anno/finance/sendSmsMessage", {
      instId: getParameterByName("instId") || User.instId(),
      scene: "nc_login_h5",
      serverType: "INST_WALLET_REBIND_WECHAT",
      sessionId: checkData.csessionid,
      sig: checkData.sig,
      token: checkData.token,
    })
      .then(() => {
        message("验证码已发送");
      })
      .catch(() => {
        this.timer && clearInterval(this.timer);
        this.setState({
          text: "获取验证码",
          countdown: 60,
        });
      });
  }

  countdownTick = () => {
    this.state.countdown = this.state.countdown - 1;
    if (this.state.countdown <= 0) {
      this.timer && clearInterval(this.timer);
      this.setState({
        text: "获取验证码",
        countDownDisable: false,
        countdown: 60,
      });
    } else {
      this.setState({
        text: this.state.countdown + "s",
        countDownDisable: true,
      });
    }
  };

  render() {
    const { banner, name, phone } = this.state;
    const avatar = User.avatar();
    const nickName = User.nickName();
    return (
      <div className="bind-page">
        <div className="bind-page-top">
          <img src={banner} alt="" className="banner" />
          <div className="inst-name">{name}</div>
          <div className="bind-tips">
            <div className="bind-title">小麦钱包</div>
            <div className="bind-subtitle">申请绑定当前微信零钱账户</div>
          </div>
          <div className="wechat-page-content">
            <div className="title">微信零钱</div>
            <div className="info-content">
              <img src={avatar} alt="" className="info-avatar" />
              <span className="info-name">{nickName}</span>
            </div>
            <img
              src="https://assets.xiaomai5.com/res/xm/PNR5x66ykS.png"
              alt=""
              className="water-mark"
            />
          </div>
          <div className="verify-content">
            <div className="verify-tips">
              为了保障您的资金安全，我们需要对主帐号身份进行短信确认，请输入
              {phone}收到的短信校验码
            </div>
            <div className="formBox yzm">
              <input
                type="text"
                value={this.state.code}
                onChange={(e) => {
                  this.setState({ code: e.target.value });
                }}
                onBlur={this.inputBlur}
                maxLength={6}
                placeholder="请输入验证码"
              />
              <div
                onClick={() => {
                  this.sendCode();
                }}
                className="btn"
              >
                {this.state.text}
              </div>
            </div>
          </div>
        </div>
        <div className="bind-page-bottom">
          <div className="bind-btn" onClick={this.handleBind}>
            绑定
          </div>
          <div className="small-tips">
            1、绑定后，分销活动的收款金额可通过【小麦钱包】提现到当前微信零钱账户
            <br />
            2、如需换绑微信零钱账户，可在【小麦钱包-微信零钱账户】中操作
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(BindPage);
